export default __webpack_public_path__ + "static/media/send_chat.3cb2166f.svg";